export default {
    ML: 'Maior Lance'
}
